import React, { useMemo } from 'react'
import { Loading, Popup } from 'src/components'
import { useStyles } from './styles'

import { useGetVaccineHistoryList } from 'src/hooks/api/animal'
import { VaccineHistoryAnimalDto } from 'src/dto/animal.dto'
import { formatDate } from 'src/utils'

interface SelectedVacineModalProps {
  isOpen: boolean
  setIsOpenSelectedVacineModal: (isOpen: boolean) => void
  idAnimal: string
}

function groupByDate(items: VaccineHistoryAnimalDto[]) {
  const grouped = new Map<string, VaccineHistoryAnimalDto[]>()

  const sorted = [...items].sort((a, b) => {
    const dateA = a.dataAplicacao ? new Date(a.dataAplicacao).getTime() : 0
    const dateB = b.dataAplicacao ? new Date(b.dataAplicacao).getTime() : 0
    return dateB - dateA
  })

  for (const item of sorted) {
    const key = item.dataAplicacao ?? 'sem-data'
    const dateKey = key !== 'sem-data' ? key.split('T')[0] : key

    if (!grouped.has(dateKey)) {
      grouped.set(dateKey, [])
    }
    grouped.get(dateKey)!.push(item)
  }

  return grouped
}

export const AnimalVaccinesHistoricModal: React.FC<SelectedVacineModalProps> = ({
  isOpen,
  idAnimal,
  setIsOpenSelectedVacineModal
}) => {
  const styles = useStyles()

  const { data: vaccineHistoryList, isLoading, refetch, isError } = useGetVaccineHistoryList(idAnimal!)

  const groupedHistory = useMemo(() => {
    if (!vaccineHistoryList?.length) return null
    return groupByDate(vaccineHistoryList)
  }, [vaccineHistoryList])

  if (!isOpen) return null

  return (
    <Popup title='Histórico Sanitário' isOpen={isOpen} onClose={() => setIsOpenSelectedVacineModal(false)}>
      <div className={styles.modalContent}>
        {isLoading || isError ? (
          <div className={styles.loadingContainer}>
            <Loading isError={isError} refetch={refetch} />
          </div>
        ) : groupedHistory ? (
          <div className={styles.historyList}>
            {Array.from(groupedHistory.entries()).map(([dateKey, items]) => (
              <div key={dateKey} className={styles.dateGroup}>
                <span className={styles.dateHeader}>
                  {dateKey !== 'sem-data' ? formatDate(dateKey) : 'Sem data'}
                </span>
                <div className={styles.dateItems}>
                  {items.map((item) => (
                    <div key={item.id} className={styles.card}>
                      <div className={styles.info}>
                        <span>{item.descricao || '-'}</span>
                        {item.dose && <span>Dose: {item.dose}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <span className={styles.noHistory}>Animal sem histórico de medicamentos.</span>
        )}
      </div>
    </Popup>
  )
}
